<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ validate, reset }">
      <v-card>
        <v-card-title class="pa-0">
          <v-title>{{isUpdating ? 'Edit' : 'Add'}} User</v-title>
        </v-card-title>
        <v-card-text>
          <v-form pa-0 ma-0 v-model="valid" lazyValidation>
            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="salesRep"
                    rules="required"
                  >
                    <v-autocomplete
                      label="Sales Representative"
                      v-model="userTarget.salesRep"
                      name="salesRep"
                      :items="filterDealers"
                      search-input.sync="model"
                      item-text="dealerFullName"
                      item-value="dealerFullName"
                      auto-select-first
                      clearable
                    >
                    </v-autocomplete>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs12 md6>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="salesStream"
                    rules="required"
                  >
                    <v-select
                      :items="['Channel', 'Direct', 'TAM']"
                      v-model="userTarget.salesStream"
                      label="Sales Stream"
                      name="salesStream"
                    ></v-select>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs12 md6>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="targetType"
                    rules="required"
                  >
                    <v-select
                      :items="['MRC', 'Upfront', 'TCV']"
                      v-model="userTarget.targetType"
                      label="Target Type"
                      name="targetType"
                    ></v-select>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs12 md6>
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="target"
                    rules="required"
                  >
                    <v-text-field
                      label="Target"
                      v-model="userTarget.target"
                      name="target"
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-flex>
                <v-flex xs12 md6>
                  <ValidationProvider v-slot="{ errors }">
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="userTarget.date"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="userTarget.date"
                          label="Date"
                          append-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="userTarget.date" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                        <v-btn flat color="primary" @click="$refs.menu.save(userTarget.date)">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </ValidationProvider>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="save">Save</v-btn>
          <v-btn color="light-grey" @click="close">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    
    </ValidationObserver>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions: mapEmployeeActions } = 
  createNamespacedHelpers(`orders/employee`);
const { mapActions: mapCommissionTargetsActions } = 
  createNamespacedHelpers(`orders/commissionTargets`);
const { mapActions: mapDealerActions } =
  createNamespacedHelpers(`orders/dealer`);

export default {
	name: "EmployeeDetail",
	props: {
		details: {
			type: Object,
			required: true
		},
		isUpdating: {
			type: Boolean
		}
	},
	data () {
		return {
      valid: true,
			userTarget: {},
			new_headAgent: null,
			allDealers: [],
			toFilter: [],
			items: ["Admin", "Employee"],
			hasDuplicateEmail: false,
      menu: false
		};
	},
  computed: {
    filterDealers(){
      let vm = this
      if(vm.userTarget.salesRep == null) return vm.allDealers
      return vm.allDealers.filter(x => x.dealerFullName.includes(vm.userTarget.salesRep))
    },
  },
  watch: {
    new_headAgent (val) {
      let vm = this
      if(val != undefined)
        vm.toFilter = vm.allDealers.filter(x => x.dealerFullName.includes(vm.userTarget.salesRep))
    }
  },
	methods: {
    ...mapEmployeeActions([
      'addEmployee',
      'getUBDealers',
      'deleteEmployee'
    ]),
    ...mapDealerActions([
      'listDealersManagement'
    ]),
    ...mapCommissionTargetsActions([
      'upsertCommissionTargets',
    ]),
    close() {
      this.$emit("close");
    },
    save() {
      let vm = this
      vm.$refs.observer.validate().then(result => {
        if(result)
          vm.upsertCommissionTargets(vm.details).then(data => {
            this.$emit("close");

            if(vm.isUpdating)  
              vm.$refs.observer.reset()

          })
      })
    },
    confirmDelete() {
			let vm = this;
			vm.$dialog
				.confirm("You are about to delete employee, are you sure?")
				.then(() => {
					vm.deleteEmployee(vm.userTarget)
						.then((data) => {
							vm.$emit("close");
						})
						.catch(() => { })
            .finally(() => {
							vm.$emit("close");
            });
				})
				.catch(() => { });
    }
	},
	mounted () {
		let vm = this;
    vm.userTarget = vm.details
    vm.new_headAgent = vm.head == 0 ? null : vm.head

    vm.listDealersManagement().then(data => {
      vm.allDealers = data.filter(x => x.dealerStatus != 'Customer')
    })
	}
};
</script>

<style scoped>
</style>
